module.exports = __webpack_public_path__ + "img/about3.d8d299f2.png";